import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import NewCallListModal from 'components/modals/new_call_list_modal';

import { endNewCallList } from '../../store/actions/people';
import { createCallListWithTasks } from '../../store/actions/call_lists';
import { getDatabaseMembers, getShowNewCallListModal } from '../../store/selectors/people';
import { getPeople } from '../../store/selectors/search';
import { getSelectedPersonIds } from '../../store/selectors/select_list';
import { getAvailableDatabases, getCurrentUser } from '../../store/selectors/static';

export class PeopleNewCallListModal extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    people: PropTypes.array.isRequired,
    selectedPersonIds: PropTypes.array.isRequired,
    showModal: PropTypes.bool.isRequired,
    onCancelNewCallList: PropTypes.func.isRequired,
    onCreateCallList: PropTypes.func.isRequired
  };

  handleCreateCallList = (data) => {
    const { selectedPersonIds, onCancelNewCallList, onCreateCallList } = this.props;
    onCreateCallList(data, selectedPersonIds);
    onCancelNewCallList();
  }

  getPerson(id) {
    return this.props.people.find(person => (
      person.id === id
    ));
  }

  render() {
    const {
      availableDatabases,
      currentUser,
      selectedPersonIds,
      showModal,
      databaseMembers,
      onCancelNewCallList
    } = this.props;

    const selectedContacts = [];
    selectedPersonIds.forEach((id) => {
      const person = this.getPerson(id) || { id: id, unloaded: true };
      selectedContacts.push(person);
    });

    const defaultAssociatedModels = [
      {
        associatedModelId: 1,
        associatedModelType: "Multiple",
        name: "Multiple Contacts",
        default: true
      }
    ];

    return (
      <NewCallListModal
        availableDatabases={availableDatabases}
        currentUser={currentUser}
        databaseMembers={databaseMembers}
        defaultAssociatedModels={defaultAssociatedModels}
        selectedContacts={selectedContacts}
        shown={showModal}
        onCancel={onCancelNewCallList}
        onSubmit={this.handleCreateCallList}
      />
    );
  }
}

const mapStateToProps = state => ({
  availableDatabases: getAvailableDatabases(state),
  currentUser: getCurrentUser(state),
  databaseMembers: getDatabaseMembers(state),
  people: getPeople(state),
  selectedPersonIds: getSelectedPersonIds(state),
  showModal: getShowNewCallListModal(state)
});

const mapDispatchToProps = {
  onCancelNewCallList: endNewCallList,
  onCreateCallList: createCallListWithTasks,
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleNewCallListModal);
